import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MerchantsArchiveDialog } from 'pages/Merchants/components/MerchantsArchiveDialog/MerchantsArchiveDialog';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useEditController, useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButton, DeleteButton } from 'shared/mui/Buttons';
import { TypographyWithBold } from 'shared/mui/Typography';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Merchant } from 'types/embedded/merchant';
import { Permission } from 'types/embedded/permission';

import { MerchantsEditForm } from './MerchantsEditForm';

export const MerchantsEdit: React.FC = () => {
  const translate = useTypedTranslate();
  const { record } = useEditController();
  const { hasResourcePermissions } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();

  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<Merchant>();

  const onSuccess = (merchant: Merchant) => {
    notify(
      <TypographyWithBold
        text={translate('app.merchants.merchantEdited', { name: merchant.name })}
      />,
      { type: 'success' },
    );
    redirect('list', Resources.Merchants);
  };

  return (
    <EditGuesserPage
      leftActionsSlot={
        hasResourcePermissions('merchants', [Permission.Full, Permission.Delete]) ? (
          <DeleteButton
            label="Архивировать"
            onClick={() => handleOpenRecordModal()}
            variant="outlined"
          />
        ) : undefined
      }
      listName="Мерчанты"
      mutationOptions={{
        onError: () => undefined,
        onSuccess,
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" label="Сохранить" />,
      ]}
      title="Редактирование мерчанта"
    >
      {openRecordModal && (
        <MerchantsArchiveDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        >
          <CancelButton
            label="Вернуться к списку мерчантов"
            linkType="back"
            sx={{ marginLeft: 'auto' }}
            variant="outlined"
          />
        </MerchantsArchiveDialog>
      )}
      <MerchantsEditForm />
    </EditGuesserPage>
  );
};
